import { initApiClient } from './api/client.js';
import { attachNotificationsGlobals } from './modules/notifications.js';
import { attachPricingGlobals } from './modules/pricing.js';
import { attachMoneyGlobals } from './modules/money.js';
import { initAjaxSecurityPrefilter } from './modules/security.js';
import { attachCajaGlobals } from './modules/caja.js';
import { attachCajaPrintGlobals } from './modules/caja-print.js';
import { attachPaymentMethodHelpers } from './modules/payment-method-helpers.js';
import { attachStockGlobals, initStockLivePolling } from './modules/stock.js';
import { initCatalogSync } from './modules/catalog-sync.js';
import { attachCartServiceGlobals } from './modules/cart-service.js';
import { attachCartUiGlobals } from './modules/cart-ui.js';
import { attachCartPanelGlobals } from './modules/cart-panel.js';
import { attachProductsSearchGlobals } from './modules/products-search.js';
import { initBarcodeCamera } from './modules/barcode-camera.js';
import { attachProductsPaginationGlobals } from './modules/products-pagination.js';
import { attachOrdersQueueGlobals, initOrderState } from './modules/orders-queue.js';
import { attachOrderProcessGlobals } from './modules/order-process.js';
import { attachProductModalGlobals } from './modules/product-modal.js';
import { attachCustomersGlobals } from './modules/customers.js';
import { attachMesasPosGlobals } from './modules/mesas-pos.js';
import { attachDiscountsGlobals } from './modules/discounts.js';
import { attachComandaPrintGlobals } from './modules/comanda-print.js';
import { attachMesasAdminGlobals } from './modules/mesas-admin.js';
import { attachPaymentModalGlobals } from './modules/payment-modal.js';
import { attachOrderDraftGlobals } from './modules/order-draft.js';
import { attachHeldOrdersGlobals } from './modules/held-orders.js';
import { attachKniaQueueGlobals } from './modules/knia-queue.js';
import { attachOrdersReadyGlobals } from './modules/orders-ready.js';
import { attachModuleNavGlobals } from './modules/module-nav.js';
import { attachPedidosAdminGlobals } from './modules/pedidos-admin.js';
import { attachCierreAdminGlobals } from './modules/cierre-admin.js';
import { attachInventarioAdminGlobals } from './modules/inventario-admin.js';
import { attachGastosAdminGlobals } from './modules/gastos-admin.js';
import { attachCreditsPosGlobals } from './modules/credits-pos.js';
import { attachModalUtilsGlobals } from './modules/modal-utils.js';
import { attachRegistersGlobals } from './modules/registers.js';
import { initSessionKeepalive } from './modules/session-keepalive.js';
import { initConnectionStatus } from './modules/connection-status.js';
import { initServerProbe } from './modules/server-probe.js';
import { initSwSync } from './modules/sw-sync.js';
import { initOfflineSnapshot } from './modules/offline-snapshot.js';
import { initTiendaSelector } from './modules/tienda-selector.js';
import { initExchangeRateRefresh } from './modules/exchange-rate.js';
import { attachPrintSettingsGlobals } from './modules/print-settings.js';
import { attachPrintBridgeGlobals } from './modules/print-bridge.js';

export function bootstrapPosApp() {
	const win = window;
	const run = () => {
		const $ = win.jQuery;
		if (!$) {
			console.error('POSKN App: jQuery no está disponible');
			return;
		}

		const cfg = win.POSKN_API_CONFIG || {};
		win.posNonce = win.posNonce || cfg.posNonce || '';

		initApiClient(win, $);
		attachNotificationsGlobals(win, $);
		initOrderState(win);
		attachPricingGlobals(win, $);
		attachMoneyGlobals(win);
		initAjaxSecurityPrefilter(win, $);
		attachStockGlobals(win);
		initCatalogSync(win);
		initStockLivePolling(win);
		attachPaymentMethodHelpers(win);
		attachModalUtilsGlobals(win, $);
		attachPrintSettingsGlobals(win, $);
		attachPrintBridgeGlobals(win);
		attachCajaPrintGlobals(win);
		attachCajaGlobals(win, $);
		attachCartServiceGlobals(win, $);
		attachCartUiGlobals(win, $);
		attachCartPanelGlobals(win, $);
		attachProductsSearchGlobals(win, $);
		initBarcodeCamera(win, $);
		attachProductsPaginationGlobals(win, $);
		attachOrdersQueueGlobals(win, $);
		attachOrderProcessGlobals(win, $);
		attachProductModalGlobals(win, $);
		attachCustomersGlobals(win, $);
		attachMesasPosGlobals(win, $);
		attachDiscountsGlobals(win, $);
		attachComandaPrintGlobals(win, $);
		attachMesasAdminGlobals(win, $);
		attachPaymentModalGlobals(win, $);
		attachOrderDraftGlobals(win, $);
		attachHeldOrdersGlobals(win, $);
		attachKniaQueueGlobals(win, $);
		attachOrdersReadyGlobals(win, $);
		attachModuleNavGlobals(win, $);
		attachPedidosAdminGlobals(win, $);
		attachCierreAdminGlobals(win, $);
		attachInventarioAdminGlobals(win, $);
		attachGastosAdminGlobals(win, $);
		attachCreditsPosGlobals(win, $);
		attachRegistersGlobals(win, $);
		// Puede reintentar si el DOM del select aún no estaba.
		win._posknTiendaSelectorInit = false;
		// Fijar tienda asignada cuanto antes (antes de estado de caja).
		if (win.POSKN_MULTITIENDA) {
			const assigned =
				win.posknUserTiendas && win.posknUserTiendas.length
					? win.posknUserTiendas
					: win.posknUserTienda
						? [win.posknUserTienda]
						: [];
			if (assigned.length === 1 && assigned[0]) {
				const id = parseInt(assigned[0].id, 10);
				win.posknTiendaSeleccionada = {
					id: Number.isNaN(id) ? 0 : id,
					nombre: assigned[0].nombre || '',
				};
				try {
					sessionStorage.setItem('poskn_session_tienda_id', String(win.posknTiendaSeleccionada.id));
				} catch (e) {
					/* ignore */
				}
			}
		}
		initTiendaSelector(win, $);
		initExchangeRateRefresh(win, $);
		initSessionKeepalive(win, $);
		initConnectionStatus(win, $);
		initServerProbe(win, $);
		initOfflineSnapshot(win, $);
		initSwSync(win);

		win.POSKN = win.POSKN || {};
		win.POSKN.app = {
			version: (cfg && cfg.version) || '8.8.3',
			modules: [
				'api', 'notifications', 'pricing', 'security', 'stock', 'catalog-sync', 'payment-method-helpers', 'modal-utils', 'print-settings', 'print-bridge', 'thermal-ticket', 'caja', 'caja-print', 'cart-service', 'cart-ui', 'cart-panel',
				'products-search', 'barcode-camera', 'products-pagination', 'orders-queue', 'orders-queue-db', 'order-process', 'product-modal', 'customers', 'mesas-pos', 'discounts',
				'comanda-print', 'mesas-admin', 'payment-modal', 'order-draft', 'held-orders', 'knia-queue',
				'orders-ready', 'module-nav', 'pedidos-admin', 'cierre-admin', 'inventario-admin', 'gastos-admin', 'credits-pos', 'registers', 'tienda-selector', 'exchange-rate',
				'session-keepalive', 'connection-status', 'server-probe', 'offline-snapshot', 'sw-sync',
			],
		};
		if (win.POSKN_MULTITIENDA) {
			console.log(
				'POSKN tiendas asignadas:',
				win.posknUserTiendas || [],
				'| usuario tienda:',
				win.posknUserTienda || null,
			);
		}
		console.log('POSKN App bundle v' + win.POSKN.app.version + ' cargado');
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', run);
	} else {
		run();
	}
}

bootstrapPosApp();
